export default __webpack_public_path__ + "static/3-538aa6682a28f5d609741cdc43b1ab21.jpeg";